module.exports = __webpack_public_path__ + "static/media/wyoming.a1255468.svg";